<button (click)="clickCompare()"
        class="action">Compare my answer with others</button>
